import React, { useState, useEffect } from 'react';
/* 
 日历格子闪烁
*/
export const useBlinkingBackground = (initialColor = 'white', targetColor = '#68B2FF') => {
  const [count, setCount] = useState(0);
  const [backgroundColor, setBackgroundColor] = useState(initialColor);

  const startBlinking = () => {
    setCount(1);
  };
  useEffect(() => {
    let intervalId: any = null;
    if (count < 5 && count > 0) {
      intervalId = setInterval(() => {
        setBackgroundColor((prevColor) => (prevColor === initialColor ? targetColor : initialColor));
        setCount((prevCount) => prevCount + 1);
      }, 400);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [count]);
  return {
    startBlinking,
    backgroundColor
  };
};
